import { render, staticRenderFns } from "./currencySettings.vue?vue&type=template&id=7df18b41&scoped=true&"
import script from "./currencySettings.vue?vue&type=script&lang=js&"
export * from "./currencySettings.vue?vue&type=script&lang=js&"
import style0 from "./currencySettings.vue?vue&type=style&index=0&id=7df18b41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df18b41",
  null
  
)

export default component.exports